module.exports = __webpack_public_path__ + "static/media/dnk.bcaa8827.png";